import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=3a714afc&scoped=true&"
import script from "./Reminders.vue?vue&type=script&lang=js&"
export * from "./Reminders.vue?vue&type=script&lang=js&"
import style0 from "./Reminders.vue?vue&type=style&index=0&id=3a714afc&lang=scss&scoped=true&"
import style1 from "./Reminders.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a714afc",
  null
  
)

export default component.exports